import { render, staticRenderFns } from "./VMainPagination.vue?vue&type=template&id=b4e5ac24"
import script from "./VMainPagination.vue?vue&type=script&lang=js"
export * from "./VMainPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports